import React from "react";
import "./insTagBadge.scss";
export const InsTagBadge = ({ text, color }) => React.createElement("div", { style: { backgroundColor: color }, className: "tag" }, text);
export const InsTagBadgeList = ({ tags }) => React.createElement("div", { className: "tagList" }, tags.map((tag) => React.createElement(InsTagBadge, { key: `tag-${tag.id}`, text: tag.label, color: tag.color })));
export default InsTagBadge;
